import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

// Thickness of the top environment border, in pixels.
export const ENV_FRAME_WIDTH = 6;

// A non-interactive colored border across the top of the viewport. The color
// is set per-environment via an inline style.
const Frame = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2147483647;
  pointer-events: none;
  border-style: solid;
  border-width: ${rem(ENV_FRAME_WIDTH)} 0 0 0;
`;

// A bold label tab centered on the top edge. Background color is set
// per-environment via an inline style.
const FrameLabel = styled.span`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147483647;
  pointer-events: none;
  padding: ${rem(5)} ${rem(18)};
  border-radius: 0 0 ${rem(4)} ${rem(4)};
  color: var(--if-on-vivid);
  font-size: ${rem(12)};
  font-weight: 700;
  letter-spacing: ${rem(1)};
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
`;

export { Frame, FrameLabel };
